import * as Phone from 'phone';

export class PhoneOperation
{
    static isValid(number: string): boolean
    {
        return Phone.phone(number).isValid;
    }
}